export default "__VITE_ASSET__DcYcRmpk__"